import React, {useCallback} from 'react';
import type {PartCodeList} from 'schemaDefinition/types';
import {useCodelist} from 'services/codelists';
import {useTextValue} from 'schema/preview/hooks';
import type {BaseFieldProps} from '../types';
import {formatCodeListValue} from '../../functions';
import {ValueLayout} from './ValueLayout';

type Props = BaseFieldProps<PartCodeList>;

export const CodeListValue: React.FC<Props> = ({
  part,
  value,
  layoutDirection,
}) => {
  const codeList = useCodelist(part.codelistId);
  const TextValue = useTextValue();

  const renderValue = useCallback(() => {
    const formattedValue = formatCodeListValue(value, part, codeList);

    return <TextValue>{formattedValue}</TextValue>;
  }, [TextValue, codeList, part, value]);

  return (
    <ValueLayout
      renderValue={renderValue}
      part={part}
      layoutDirection={layoutDirection}
    />
  );
};
